// extracted by mini-css-extract-plugin
export var articleDetails = "smallVerticleArticleSummary-module--articleDetails--ROK6o";
export var relatedChallenge = "smallVerticleArticleSummary-module--relatedChallenge--tnWYi";
export var category = "smallVerticleArticleSummary-module--category--IOECl";
export var author = "smallVerticleArticleSummary-module--author--ffQdQ";
export var title = "smallVerticleArticleSummary-module--title--viGBk";
export var angle = "smallVerticleArticleSummary-module--angle--rejf4";
export var articleSummary = "smallVerticleArticleSummary-module--articleSummary--LnF2w";
export var slideUp = "smallVerticleArticleSummary-module--slideUp--RjN08";
export var slideUpLarge = "smallVerticleArticleSummary-module--slideUpLarge--vfvET";